import api from "@/api/api";
import {iniciarRequisicao} from "@/helpers";
import { logout } from "../../helpers";
import { STATUS_HTTP } from "../statusHTTP";

const PREFIXO = 'curva-criticidade';

export const importarArquivoCurvasCriticidade = async (arquivo) => {
  const url = `${PREFIXO}/importacao-arquivo`;

  const headers = {
    ...iniciarRequisicao(),
    'Content-Type': 'multipart/form-data'
  }

  const params = new FormData();
  params.append('arquivo', arquivo);

  const {data} = await api.post(url, params, {headers});
  localStorage.token = data.token;
  return data;
}

export const buscarListaArquivosImportados = async (params) => {
  const url = `${PREFIXO}/importacoes`;

  const {data, status} = await api.get(url, {params, headers:  iniciarRequisicao()});

  if(status !== STATUS_HTTP.OK) {
    logout()
    return;
  }

  localStorage.token = data.token;
  return data.importacoes;
}

export const buscaProdutosLista = async (params) => {
  const url = `${PREFIXO}/importacao/produtos`;

  const {data, status} = await api.get(url, {params, headers:  iniciarRequisicao()});

  if(status !== STATUS_HTTP.OK) {
    logout()
    return;
  }

  localStorage.token = data.token;
  return data.produtos;
}

